'use client'
import styles from './Button.module.sass'
import cn from 'classnames'
import {useState} from "react";
import {useGameContext} from "@/context/GameContext";

const Button = ({
	                children,
	                className,
					height,
					borderSize,
					gradientPercentage,
	                buttonPadding,
	                ...props
                }) => {

	const [isClicked, setIsClicked] = useState(false)

	const {playAudioOnce} = useGameContext()

	return <button
			className={cn(styles.button, className, 'custom_pointer')}
			style={{
				'--height': height,
				'--border_size': borderSize,
				'--gradient_percentage': gradientPercentage,
				'--btn_padding': buttonPadding,
			}}
			onClick={() => {
				playAudioOnce('/sound/button_click.mp3')
				setIsClicked(!isClicked)
			}}
			{...props}>

		{/*Left Part*/}
		<div className={styles.left_part}>
			<TopLeftButtonPart className={styles.top}/>
			<BottomLeftButtonPart className={styles.bottom}/>
		</div>

		{/*Center*/}
		<div className={styles.btn_center__container}>
			<div className={styles.btn_center}>
				{children}
			</div>
		</div>

		{/*Right Part*/}
		<div className={styles.right_part}>
			<TopRightButtonPart className={styles.top}/>
			<BottomRightButtonPart className={styles.bottom}/>
		</div>
	</button>
}
export default Button

const BottomLeftButtonPart = (props) => {
	return (

			<svg width="33" height="98" viewBox="0 0 33 98" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
				<path
						className={styles.base}
						d="M32 51H2V78H6.5V82.5H15.5V87H20C20 87 20.015 91.0191 20 91.5C20 91.5 24.0479 91.4579 24.5 91.5C24.5 91.5 24.5069 95.5125 24.5 96H32V51Z"
						fill="#169066"/>
				<path fillRule="evenodd"
				      clipRule="evenodd"
				      d="M0.00984931 52L0 77.7595C0 79.1448 1.12676 80.2716 2.51157 80.2716H4.4174V82.1922C4.4174 83.577 5.54416 84.7038 6.92897 84.7038H13.262V86.6244C13.262 88.0092 14.3888 89.1359 15.7736 89.1359H17.6844V91.0565C17.6844 92.4414 18.8111 93.5681 20.1959 93.5681H22.1067V95.4887C22.1067 96.8735 23.2335 98.0003 24.6183 98.0003L32 98V95.538H24.6183C24.5912 95.538 24.569 95.5158 24.569 95.4887V91.155C24.569 91.128 24.5469 91.1058 24.5198 91.1058H20.1959C20.1689 91.1058 20.1467 91.0836 20.1467 91.0565V86.7229C20.1467 86.6958 20.1245 86.6736 20.0974 86.6736H15.7736C15.7465 86.6736 15.7244 86.6515 15.7244 86.6244V82.2907C15.7244 82.2636 15.7022 82.2414 15.6751 82.2414H6.92897C6.90188 82.2414 6.87972 82.2193 6.87972 82.1922V77.8585C6.87972 77.8314 6.85756 77.8093 6.83047 77.8093H2.51157C2.48448 77.8093 2.46232 77.7871 2.46232 77.76L2.46642 52H0.00984931Z"
				      fill="#0D422E"/>
			</svg>
	)
}

const TopLeftButtonPart = (props) => {
	return (
			<svg width="33" height="98" viewBox="0 0 33 98" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
				<path d="M33 2H24.5C24.5 2.64724 24.5 6.5 24.5 6.5H15.5V11C14.6178 11.0376 6.5 11 6.5 11V15.5C6.04716 15.5338 2 15.5 2 15.5V51.2162C2 51.2162 6.34079 51.2162 6.78025 51.2162C6.84821 51.2162 6.90337 51.2714 6.90337 51.3393V64.3896C6.90337 64.4576 6.95852 64.5127 7.02648 64.5127H11.2124C11.2804 64.5127 11.3355 64.5679 11.3355 64.6358V68.8218C11.3355 68.8897 11.3907 68.9449 11.4587 68.9449H20.0768C20.1447 68.9449 20.1999 69 20.1999 69.068V77.6861C20.1999 77.7541 20.255 77.8092 20.323 77.8092H33V2Z"
				      fill="#EBFD6B"/>
				<path fillRule="evenodd"
				      clipRule="evenodd"
				      d="M32.9998 0H24.6821C23.2973 0 22.1705 1.12676 22.1705 2.51157V4.43217H15.8177C14.4329 4.43217 13.3062 5.55893 13.3062 6.94374V8.86435H6.95341C5.5686 8.86435 4.44184 9.99111 4.44184 11.3759V13.2965H2.52123C1.13643 13.2965 0.00967073 14.4233 0.00967073 15.8081L0 52H2.46624L2.47199 15.8081C2.47199 15.781 2.49415 15.7588 2.52123 15.7588H6.85492C6.882 15.7588 6.90416 15.7367 6.90416 15.7096V11.3759C6.90416 11.3488 6.92632 11.3267 6.95341 11.3267H15.7192C15.7463 11.3267 15.7685 11.3045 15.7685 11.2774V6.94374C15.7685 6.91665 15.7907 6.89449 15.8177 6.89449H24.5836C24.6107 6.89449 24.6328 6.87233 24.6328 6.84525V2.51157C24.6328 2.48448 24.655 2.46232 24.6821 2.46232H32.9998V0Z"
				      fill="#0D422E"/>
			</svg>
	)
}

const BottomRightButtonPart = (props) => {
	return (
			<svg width="33" height="98" viewBox="0 0 33 98" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
				<path
						className={styles.base}
						d="M1 51H31V78H26.5V82.5H17.5V87H13C13 87 12.985 91.0191 13 91.5C13 91.5 8.95214 91.4579 8.5 91.5C8.5 91.5 8.49306 95.5125 8.5 96H1V51Z"
						fill="#169066"/>
				<path fillRule="evenodd"
				      clipRule="evenodd"
				      d="M32.9902 52L33 77.7595C33 79.1448 31.8732 80.2716 30.4884 80.2716H28.5826V82.1922C28.5826 83.577 27.4558 84.7038 26.071 84.7038H19.738V86.6244C19.738 88.0092 18.6112 89.1359 17.2264 89.1359H15.3156V91.0565C15.3156 92.4414 14.1889 93.5681 12.8041 93.5681H10.8933V95.4887C10.8933 96.8735 9.7665 98.0003 8.3817 98.0003L1 98V95.538H8.3817C8.4088 95.538 8.431 95.5158 8.431 95.4887V91.155C8.431 91.128 8.4531 91.1058 8.4802 91.1058H12.8041C12.8311 91.1058 12.8533 91.0836 12.8533 91.0565V86.7229C12.8533 86.6958 12.8755 86.6736 12.9026 86.6736H17.2264C17.2535 86.6736 17.2756 86.6515 17.2756 86.6244V82.2907C17.2756 82.2636 17.2978 82.2414 17.3249 82.2414H26.071C26.0981 82.2414 26.1203 82.2193 26.1203 82.1922V77.8585C26.1203 77.8314 26.1424 77.8093 26.1695 77.8093H30.4884C30.5155 77.8093 30.5377 77.7871 30.5377 77.76L30.5336 52H32.9902Z"
				      fill="#0D422E"/>
			</svg>
	)
}

const TopRightButtonPart = (props) => {
	return (
			<svg width="33" height="98" viewBox="0 0 33 98" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
				<path
						d="M0 2H8.5C8.5 2.64724 8.5 6.5 8.5 6.5H17.5V11C18.3822 11.0376 26.5 11 26.5 11V15.5C26.9528 15.5338 31 15.5 31 15.5V51.2162C31 51.2162 26.6592 51.2162 26.2197 51.2162C26.1518 51.2162 26.0966 51.2714 26.0966 51.3393V64.3896C26.0966 64.4576 26.0415 64.5127 25.9735 64.5127H21.7876C21.7196 64.5127 21.6645 64.5679 21.6645 64.6358V68.8218C21.6645 68.8897 21.6093 68.9449 21.5413 68.9449H12.9232C12.8553 68.9449 12.8001 69 12.8001 69.068V77.6861C12.8001 77.7541 12.745 77.8092 12.677 77.8092H0V2Z"
						fill="#EBFD6B"/>
				<path fillRule="evenodd"
				      clipRule="evenodd"
				      d="M0.00018692 0H8.31788C9.70268 0 10.8295 1.12676 10.8295 2.51157V4.43217H17.1823C18.5671 4.43217 19.6938 5.55893 19.6938 6.94374V8.86435H26.0466C27.4314 8.86435 28.5582 9.99111 28.5582 11.3759V13.2965H30.4788C31.8636 13.2965 32.9903 14.4233 32.9903 15.8081L33 52H30.5338L30.528 15.8081C30.528 15.781 30.5058 15.7588 30.4788 15.7588H26.1451C26.118 15.7588 26.0958 15.7367 26.0958 15.7096V11.3759C26.0958 11.3488 26.0737 11.3267 26.0466 11.3267H17.2808C17.2537 11.3267 17.2315 11.3045 17.2315 11.2774V6.94374C17.2315 6.91665 17.2093 6.89449 17.1823 6.89449H8.41638C8.38928 6.89449 8.36719 6.87233 8.36719 6.84525V2.51157C8.36719 2.48448 8.34498 2.46232 8.31788 2.46232H0.00018692V0Z"
				      fill="#0D422E"/>
			</svg>
	)
}